import React from 'react';
import PropTypes from 'prop-types';
import cheerio from 'cheerio';

import Tooltip from '../Tooltip';
import { SIGNATURE_SRC } from '../Signature';

import { getImage } from '../../../utils/images';
import { connectTo } from '../../../utils';
import { onClickWrapper } from '../../../utils/ui';

const isUnitymedia = process.env.TENANT === 'UNITYMEDIA';

const setNewSrc = ($, className, replaceBy) => {
  const classSelector = `.${className}`;
  const element = $(classSelector);
  if (element) {
    const src = element.attr('src');
    if (src) {
      $(classSelector).attr('src', replaceBy || getImage(src));
    }
  }
};

const Translation = ({
  className,
  children,
  showTranslationTooltips,
  placement,
  translations,
  onlyForUnitymedia,
  isHtml,
  keyIfNoValue,
  inline,
  onClick,
  id,
}) => {
  if (children) {
    const translation =
      (isUnitymedia && onlyForUnitymedia) ||
      (translations && translations[children]) ||
      (keyIfNoValue ? children : '');

    let translationDiv;
    if (isHtml) {
      const $ = cheerio.load(translation);
      setNewSrc($, 'agent-signature', SIGNATURE_SRC);

      const htmlTranslation = $.html();
      translationDiv = !inline ? (
        <div
          className={className}
          style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: htmlTranslation }}
          onClick={onClick ? onClickWrapper(id, onClick) : undefined}
          id={id}
        />
      ) : (
        <span
          className={className}
          style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: htmlTranslation }}
          onClick={onClick ? onClickWrapper(id, onClick) : undefined}
          id={id}
        />
      );
    } else {
      translationDiv = !inline ? (
        <div
          className={className}
          style={{ whiteSpace: 'pre-wrap' }}
          onClick={onClick ? onClickWrapper(id, onClick) : undefined}
          id={id}
        >
          {translation}
        </div>
      ) : (
        <span
          className={className}
          style={{ whiteSpace: 'pre-wrap' }}
          onClick={onClick ? onClickWrapper(id, onClick) : undefined}
          id={id}
        >
          {translation}
        </span>
      );
    }

    if (showTranslationTooltips && !(isUnitymedia && onlyForUnitymedia)) {
      translationDiv = (
        <Tooltip title={children} placement={placement || 'top'}>
          {translationDiv}
        </Tooltip>
      );
    }
    return translationDiv;
  } else {
    return null;
  }
};

Translation.propTypes = {
  className: PropTypes.string,
  children: PropTypes.string,
  placement: PropTypes.string,
  isHtml: PropTypes.bool,
};

Translation.defaultProps = {
  isHtml: false,
};

export default connectTo(
  ({ ui: { showTranslationTooltips }, translations: { translations } }) => ({
    showTranslationTooltips,
    translations,
  }),
  {},
  Translation
);
